import { connect } from 'react-redux'
import ProductListViewMyStore from './ProductListViewMyStore'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewMyStore)
